/** Captura de utm_source/utm_medium/utm_campaign/?ref= (Fase 3 del CRM de leads) — se guarda
 *  en sessionStorage al aterrizar (ver captureUtmFromUrl en __root.tsx) y se adjunta al lead
 *  cuando se envía el formulario de /contacto o el de una página de sede (ver getStoredUtm).
 *  "Último toque" dentro de la misma sesión: si la persona llega de nuevo con otros parámetros
 *  mientras navega, se sobreescriben — no hace falta un historial de touches para este tamaño
 *  de negocio (1 a 5 leads al mes). */

export type StoredUtm = { utmSource?: string; utmMedium?: string; utmCampaign?: string; ref?: string };

const STORAGE_KEY = "cp_lead_attribution";

/** Se llama una sola vez al montar el layout raíz. No hace nada si la URL no trae ninguno de
 *  estos parámetros — así no borra una atribución ya capturada antes en la misma sesión solo
 *  porque la persona navegó a otra página sin querystring. */
export function captureUtmFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get("utm_source") || undefined;
    const utmMedium = params.get("utm_medium") || undefined;
    const utmCampaign = params.get("utm_campaign") || undefined;
    const ref = params.get("ref") || undefined;
    if (!utmSource && !utmMedium && !utmCampaign && !ref) return;
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ utmSource, utmMedium, utmCampaign, ref }));
  } catch {
    // sessionStorage puede no estar disponible (modo privado, navegador viejo, etc.) — la
    // atribución es un extra, nunca debe romper la navegación normal del sitio.
  }
}

/** undefined si nunca se capturó nada en esta sesión (visita directa, sin utm/ref). */
export function getStoredUtm(): StoredUtm | undefined {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as StoredUtm) : undefined;
  } catch {
    return undefined;
  }
}
